import { render, staticRenderFns } from "./ListaDirectorio.vue?vue&type=template&id=1a849f1c"
import script from "./ListaDirectorio.vue?vue&type=script&lang=js"
export * from "./ListaDirectorio.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports